export default function Maintenance() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.title}>We’ll Be Right Back</h1>
        <p style={styles.text}>
          Our site is currently under maintenance.<br />Thank you for your patience.
        </p>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    height: "100vh",
    width: "100%",
    background: "linear-gradient(135deg, #4e73df, #1cc88a)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: "rgba(255, 255, 255, 0.15)",
    padding: "40px 35px",
    borderRadius: "20px",
    textAlign: "center",
    backdropFilter: "blur(10px)",
    color: "#fff",
    width: "90%",
    maxWidth: "450px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    animation: "fadeIn 1s ease-in-out",
  },
  title: {
    fontSize: "32px",
    marginBottom: "10px",
    fontWeight: 600,
  },
  text: {
    fontSize: "18px",
    opacity: 0.9,
  },
  loader: {
    width: "60px",
    height: "60px",
    border: "6px solid rgba(255,255,255,0.3)",
    borderTopColor: "#fff",
    borderRadius: "50%",
    margin: "0 auto 20px auto",
    animation: "spin 1s linear infinite",
  },
};

// Inject animations
const animationStyle = document.createElement("style");
animationStyle.innerHTML = `
@keyframes spin {
  to { transform: rotate(360deg); }
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
`;
document.head.appendChild(animationStyle);
